import orderBy from 'lodash/orderBy';
import uniqBy from 'lodash/uniqBy';

/**
 * Also order the notifications by date
 */
export function getUniqueNotifications(notifications) {
  return orderBy(
    uniqBy(notifications, 'slug'),
    (o) => new Date(o.date),
    'desc'
  );
}
